/**
 * Configurations read from .env files
 */
export default {
  s3: {
    REGION: process.env.REACT_APP_REGION,
    BUCKET: process.env.REACT_APP_BUCKET_NAME,
  },
  apiGateway: {
    REGION: process.env.REACT_APP_REGION,
    URL: process.env.REACT_APP_ENDPOINT_URL,
    WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
  },
  cognito: {
    REGION: process.env.REACT_APP_REGION,
    USER_POOL_ID: process.env.REACT_APP_COGNITO_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
  },
  crypto: {
    INFURA_KEY: process.env.REACT_APP_INFURA_KEY,
    TRIPSHA_WALLET_ADDRESS: process.env.REACT_APP_TRIPSHA_WALLET_ADDRESS,
  },
  environment: {
    NAME: process.env.REACT_APP_ENV_NAME,
  },
}
